import { useState } from "react";
import useReveal from "../hooks/useReveal";
import { portfolio } from "../data/mock";

const filters = ["ALL", "WEDDING & ANNIVERSARY", "BABY SHOWER", "DINING", "BIRTHDAY", "GRADUATION"];

export default function Portfolio() {
  const [f, setF] = useState("ALL");
  const matchesFilter = (p) => {
    if (f === "ALL") return true;
    if (Array.isArray(p.tag)) return p.tag.includes(f);
    return p.tag === f;
  };
  const items = portfolio.filter(matchesFilter);
  const primaryTag = (p) => (Array.isArray(p.tag) ? p.tag[0] : p.tag);
  useReveal([f]);

  return (
    <div className="pt-32">
      <section className="mx-auto max-w-[1400px] px-6 md:px-10 py-16">
        <div className="kicker reveal">Portfolio</div>
        <h1 className="font-display text-4xl md:text-7xl leading-[1.02] mt-6 reveal">
          A curated selection of <span className="italic">signature weddings</span> and <span className="italic">prestige events</span>.
        </h1>
        <div className="mt-12 flex flex-wrap gap-x-6 gap-y-3 text-[11px] tracking-[0.3em] uppercase">
          {filters.map((flt) => (
            <button
              key={flt}
              onClick={() => setF(flt)}
              className={`py-1 border-b ${f === flt ? "border-[hsl(var(--ink))]" : "border-transparent hover:border-[hsl(var(--line))]"}`}
            >
              {flt}
            </button>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 pb-24">
        <div className="grid md:grid-cols-2 gap-8 md:gap-14">
          {items.map((p, i) => (
            <div key={p.id} className={`reveal ${i % 2 ? "md:mt-24" : ""}`}>
              <div className="img-zoom">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-[520px] object-cover"
                  style={p.objectPosition ? { objectPosition: p.objectPosition } : undefined}
                />
              </div>
              <div className="flex justify-between items-baseline mt-5">
                <h3 className="font-display text-2xl md:text-3xl">{p.title}</h3>
                <span className="kicker text-[hsl(var(--accent))]">{primaryTag(p)}</span>
              </div>
              <div className="text-sm text-[hsl(var(--ink-soft))] mt-1">{p.location}</div>
            </div>
          ))}
        </div>
        {items.length === 0 && (
          <div className="text-center py-24 text-[hsl(var(--ink-soft))]">No projects in this category yet.</div>
        )}
      </section>
    </div>
  );
}
